import MobileDetect from 'mobile-detect'

// 获取URL参数对象
function GetRequest() {
  // 获取url中“？”符后的字符串
  // let url = location.search
  // vue-router为 hash模式时
  const url = location.href
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    const str = url.split('?')[1]
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      const sep = strs[i].indexOf('=')
      theRequest[strs[i].substr(0, sep)] = strs[i].substr(sep + 1, strs[i].length)
    }
  }
  return theRequest
}

// 获取URL参数值
export function GetRequestParam (paramName) {
  let request = {}
  request = GetRequest()
  if (typeof request[paramName] === 'undefined') {
    return ''
  }
  return request[paramName].split('#')[0]
  // return (typeof request[paramName] === 'undefined') ? '' : request[paramName]
}

// 获取设备相关信息
export function getMobileInfo() {
  // 获取userAgent信息
  const ua = window.navigator.userAgent
  // 初始化mobile-detect
  const md = new MobileDetect(ua)
  const mobile = md.mobile()
  const os = md.os()
  let model = ''
  let version = ''
  if (os === 'iOS') {
    // ios系统的处理
    version = md.version(mobile)
    model = md.mobile()
  } else if (os === 'AndroidOS') {
    // Android系统的处理
    version = md.version('Android')
    const arr = ua.split(';')
    for (const i in arr) {
      if (arr[i].indexOf('Build/') > 0) {
        model = arr[i].substring(0, arr[i].indexOf('Build/'))
        break
      }
    }
  }

  return {
    ua: ua,
    mobile: model,
    os,
    version,
    browser: md.userAgent(),
    network: getNetworkType()
  }
}

// 获取设备的网络信息
function getNetworkType() {
  const ua = navigator.userAgent
  let networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other'
  networkStr = networkStr.toLowerCase().replace('nettype/', '')

  let networkType
  switch (networkStr) {
    case 'wifi':
      networkType = 'wifi'
      break
    case '4g':
      networkType = '4g'
      break
    case '3g':
      networkType = '3g'
      break
    case '3gnet':
      networkType = '3g'
      break
    case '2g':
      networkType = '2g'
      break
    default:
      networkType = 'other'
  }
  return networkType
}
